import { useQuery } from "react-query";
import sortBy from "lodash/sortBy";
import { useContext } from "react";
import { AuthContext } from "src/App/components/Auth";
import { API_URL } from "src/constants";
const FIVE_MINUTES = 300000;
const fetchDefinitions = (auth) => async () => {
    console.log(auth);
    const response = await window.fetch(`${API_URL}/`, {
        method: "GET",
        headers: {
            authorization: `Bearer ${auth?.idToken}`,
        },
    });
    const data = await response.json();
    const sortedData = sortBy(data, (a) => a.searchString);
    sessionStorage.setItem("totalAcronyms", sortedData.length.toString());
    return sortedData;
};
const useDefinitions = () => useQuery("definitions", fetchDefinitions(useContext(AuthContext)), {
    staleTime: FIVE_MINUTES,
    retry: false,
});
export default useDefinitions;
